import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../common/TextInput';
import PasswordInput from '../common/PasswordInput'

const RegistrationForm = ({email, emailConfirm, errors, password, passwordConfirm, onChange, onSubmit}) => {

  return (
    <div className="af-form">
      <TextInput
        name="email"
        label="Email"
        isRequired={true}
        onChange={onChange}
        placeholder='ej: my@email.com'
        value={email}
        error={errors.email} />

      <TextInput
        name="emailConfirm"
        label="Confirm Email"
        isRequired={true}
        onChange={onChange}
        placeholder=''
        value={emailConfirm}
        error={errors.email} />

      <PasswordInput
        name="password"
        label="Password"
        isRequired={true}
        onChange={onChange}
        placeholder=''
        value={password}
        error={errors.password} />

      <PasswordInput
        name="passwordConfirm"
        label="Confirm Password"
        isRequired={true}
        onChange={onChange}
        placeholder=''
        value={passwordConfirm}
        error={errors.password} />

      <div>
        <input type="submit" className="af-submit" value="Register" onClick={onSubmit} />
      </div>
    </div>
  );
}

RegistrationForm.propTypes = {
  /**
   * User email address
   */
  email: PropTypes.string.isRequired,
  emailConfirm: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  passwordConfirm: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.array
};

// errors: PropTypes.object.isRequired,
export default RegistrationForm;



// WEBPACK FOOTER //
// ./src/components/registration/RegistrationForm.js